export default "__VITE_ASSET__CFP54_mc__"